import { render, staticRenderFns } from "./studentHead.vue?vue&type=template&id=573313f8&scoped=true"
import script from "./studentHead.vue?vue&type=script&lang=js"
export * from "./studentHead.vue?vue&type=script&lang=js"
import style0 from "./studentHead.vue?vue&type=style&index=0&id=573313f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573313f8",
  null
  
)

export default component.exports